const checkLogin = (currentUser) => currentUser && currentUser.isLoggedIn;

export default checkLogin;
